import { useEffect, useCallback } from 'react';
import gql from 'graphql-tag.macro';
import { useMutation } from '@apollo/react-hooks';
import { useDispatch } from 'react-redux';

import { logout } from 'ducks/auth';
import paths from 'paths';

import { logout as logoutHandler } from 'utils/appWebView';
import useSearchParams from 'hooks/useSearchParams';
import useAuthToken from 'hooks/useAuthToken';

const LOGOUT = gql`
  mutation logout {
    logout {
      result {
        __typename
      }
    }
  }
`;

const Logout = () => {
  const params = useSearchParams();
  const dispatch = useDispatch();
  const isLoggedIn = !!useAuthToken();

  const onCompleted = useCallback(() => {
    dispatch(logout());
    logoutHandler();
    paths.replace(paths.시작.index(window.location.search));
  }, [dispatch]);

  const [startLogout] = useMutation(LOGOUT, { onCompleted });

  useEffect(() => {
    // 토큰 없는 상태에서 로그아웃 라우트로 들어올 경우 api 요청은 스킵
    if (!isLoggedIn) {
      onCompleted();
      return;
    }

    if (params.deactivate) {
      onCompleted();
    } else {
      startLogout();
    }
  }, [startLogout, onCompleted, params.deactivate, isLoggedIn]);

  return null;
};

export default Logout;
